import Program from "wwg-utilities/dist/collections/program";
import Provider from "wwg-utilities/dist/collections/provider";
import gaDataLayerEvent from "../../../lib/hooks/GA/gaDataLayerEvent";
import ReadMore from "../ReadMore";
import RenderRichText from "../RenderRichText";

interface AboutProps {
    program: Program;
}

const About: React.FC<AboutProps> = ({ program }) => {
    return (
        <section className="w-full lg:p-8">
            <h2 className="mb-2 text-2xl font-bold text-primary-dark">
                About
            </h2>
            <div
                onClick={() => {
                    gaDataLayerEvent({
                        event: 'tab_click',
                        clicked_tab: {
                            program_name: `${program.name} at ${(program.institution as Provider).name
                                }`,
                            title: 'read more',
                            value: 'about section',
                        },
                    });
                }}
            >
                <ReadMore>
                    <div className="font-light font-base text-paragraph">
                        <RenderRichText html={program.about}></RenderRichText>
                    </div>
                </ReadMore>
            </div>
        </section>);
};

export default About;